"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TAB_LINKS_SLIDE_VALUE = exports.DEFAULT_TAB_LINKS_ID_PREFIX = exports.DEFAULT_TAB_LINKS_CONTAINER_ID = void 0;
var DEFAULT_TAB_LINKS_CONTAINER_ID = 'tab-links-container';
exports.DEFAULT_TAB_LINKS_CONTAINER_ID = DEFAULT_TAB_LINKS_CONTAINER_ID;
var DEFAULT_TAB_LINKS_SLIDE_VALUE = 500;
exports.DEFAULT_TAB_LINKS_SLIDE_VALUE = DEFAULT_TAB_LINKS_SLIDE_VALUE;
var DEFAULT_TAB_LINKS_ID_PREFIX = 'tab-link-wrapper';
exports.DEFAULT_TAB_LINKS_ID_PREFIX = DEFAULT_TAB_LINKS_ID_PREFIX;